import React from 'react';

import { REQUIRED_DOT } from '@/utils/constants/AppConstants';
import { ColorDefault } from '@/utils/themes/color';

interface IViewDetail {
  required?: boolean;
  editRole: boolean;
  value: string | null | undefined | React.ReactNode;
  label: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
}

const ViewDetail = ({ required, label, value, editRole, children, icon }: IViewDetail) => {
  return editRole ? (
    children
  ) : (
    <div>
      <div className='label-container mr-2 flex items-center !mb-2 max-h-[38px]'>
        <div>{label ?? ''}</div>
        {required && (
          <div className='require' color={ColorDefault.negative}>
            {REQUIRED_DOT}
          </div>
        )}
      </div>
      <div className='px-4 py-[10px] border border-solid border-[#dbdbe0] rounded-[10px] leading-[16px] text-[#525a68] font-bold flex items-center'>
        {icon}
        {value || '--'}
      </div>
    </div>
  );
};

export default ViewDetail;
